import { type RoundAggregate } from "@engine/round/aggregate";
import { type UserProfiles } from "@lib/types";
import userIsSfcAdmin from "./userIsSfcAdmin";

export default function userIsAdmin(
  userId: string,
  context: {
    round: RoundAggregate;
    userProfiles: UserProfiles;
    effectiveIsSfcAdmin: boolean;
    /** @deprecated Use effectiveIsSfcAdmin instead */
    underlyingUserIsSfcAdmin?: boolean;
  },
) {
  const { round } = context;
  const fallback =
    context.effectiveIsSfcAdmin ?? context.underlyingUserIsSfcAdmin ?? false;
  const userIsRoundAdmin = round.members[userId]?.isRoundAdmin ?? fallback;
  return userIsRoundAdmin || userIsSfcAdmin(userId, context);
}
